import React, {
    useEffect, useState, useRef,
    useMemo,
    useCallback
} from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "./settings.css"
import ReactDragListView from 'react-drag-listview';
import "font-awesome/css/font-awesome.min.css";
import CustomModal from '../../components/customModal/CustomModal'
import Table from "../Table";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useSelector, useDispatch } from "react-redux";
import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
import { saveOrderApi, getStages, getPiplines, getStagesCount, addStage, editStageApi, addPipeline, editPipelineApi, getPiplinesCount } from '../../api/SettingsApi'
import { toast } from "react-toastify";
import { setSelectedPipelineId, setSelectedPipelineName } from "ReduxStore/Slices/settingsSlice";

function Stage(props) {
    const [pipelines, setPipelines] = useState([]);
    const [dataApi, setDataApi] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [showStageModal, setShowStageModal] = useState(false)
    const [showPipelineModal, setShowPipelineModal] = useState(false)
    const [pipelineCount, setPipelineCount] = useState(0)
    const [focusedStage, setFocusedStage] = useState(null)
    const [editStage, setEditStage] = useState(null)
    const [editPipeline, setEditPipeline] = useState(null)
    const [showSave, setshowSave] = useState(false)
    const [oldOrder, setOldOrder] = useState(null)

    const { companyUserLoading } = useSelector(
        (state) => state.companyUserSetter
    );
    const { selectedPipelineId, selectedPipelineName } = useSelector((state) => state.settingsSetter);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCompanyUserLoading(true));
        let pipelines
        getPiplines(1000, 0)
            .then((data) => {
                pipelines = data;
                dispatch(setSelectedPipelineId(pipelines[0].id))
                dispatch(setSelectedPipelineName(pipelines[0].name))
                setPipelines(data)
                fetchData({ pageSize: 10, pageIndex: 0, selectedPipeline: pipelines[0].id })
            })
            .catch((e) => { })
        getPiplinesCount().then(res => {
            setPipelineCount(res.count)
        }).catch(e => { })
    }, []);

    const fetchData = useCallback(async ({ pageSize, pageIndex, selectedPipeline }) => {
        dispatch(setCompanyUserLoading(true));
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        setPageIndex(pageIndex);

        if (selectedPipeline !== "-1") {
            await getStagesCount(selectedPipeline)
                .then((data) => {
                    setPageCount(Math.ceil(data.count / pageSize));
                    setTotal(data.count);
                })
                .catch((e) => { })

            await getStages(selectedPipeline, pageSize, startRow)
                .then((data) => {
                    setDataApi(data);
                    dispatch(setCompanyUserLoading(false));

                })
                .catch((e) => { })
        } else {
            dispatch(setCompanyUserLoading(false));

            return
        }
    }, []);

    const data = useMemo(() => dataApi, [dataApi]);
    const columns = useMemo(
        () => [
            {
                Header: "Stage Name",
                accessor: "label",
                Cell: ({ cell }) => (
                    (
                        <div>
                            <a href="#" style={{
                                marginRight: "20px",
                                color: 'rgba(0,0,0,0.4)',
                                cursor: 'grab'
                            }}>
                                <i class='fas fa-grip-vertical '></i>

                            </a>
                            <span>{cell.row.original.label}</span>
                        </div>

                    )
                ),
            },

            {
                // width: 300,
                Header: "",
                accessor: "ff",
                Cell: ({ cell }) => (
                    (
                        <div >
                            <OverlayTrigger
                                delay={{ hide: 50, show: 50 }}
                                placement="top"
                                key="top"
                                overlay={(props) => (
                                    <Tooltip id="tooltip-top" {...props}>
                                        Edit Stage
                                    </Tooltip>
                                )}
                            >
                                <i
                                    className="fa fa-edit"
                                    style={{ color: "gray", fontSize: "20px" }}
                                    onClick={() => { setFocusedStage(cell.row.original.label); setEditStage(cell.row.original.id); setShowStageModal(true) }}
                                ></i>
                            </OverlayTrigger>
                            <OverlayTrigger
                                delay={{ hide: 50, show: 50 }}
                                placement="top"
                                key="top"
                                overlay={(props) => (
                                    <Tooltip id="tooltip-top" {...props}>
                                        Delete Stage
                                    </Tooltip>
                                )}
                            >
                                <i
                                    className="fa fa-trash"
                                    style={{ color: "gray", fontSize: "20px", marginLeft: "40px" }}
                                    onClick={() => handleStageDelete(cell.row.original.id)}
                                ></i>
                            </OverlayTrigger>
                        </div>
                    )
                ),
            },
        ],
        [dataApi]
    );
    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            if (!oldOrder) {
                let t = [...dataApi];
                setOldOrder(t)
            }
            const data = [...dataApi];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            setDataApi(data);
            setshowSave(true)
        },
        nodeSelector: 'tr',
        handleSelector: 'a'
    };

    //This funtion is used to update the stage 
    const handleStageUpdate = () => {
        if (editStage) {
            let label = focusedStage
            let body = {
                label: label
            }
            editStageApi(selectedPipelineId, editStage, body)
                .then((data) => {
                    let d = [...dataApi];
                    d = d.map((r) => {
                        if (r.id == data.id)
                            r.label = label
                        return r;
                    });

                    setDataApi(d)
                    setShowStageModal(false)
                    toast.success("Stage has been saved successfully");

                })

        }
        else {
            let label = focusedStage
            addStage(selectedPipelineId, label)
                .then((data) => {
                    let d = [...dataApi];
                    d.push({ id: data.id, label: label });
                    setDataApi(d)
                    setShowStageModal(false)
                    toast.success("Stage has been updated successfully");

                })
        }

    };

    //This funtion is used to update the pipeline
    const handlePipelineUpdate = () => {
        if (editPipeline) {
            let label = focusedStage
            let body = {
                name: label
            }
            editPipelineApi(editPipeline, body)
                .then((data) => {
                    setShowPipelineModal(false)
                    toast.success("Pipeline has been saved successfully");
                    fetchData({ pageSize: 10, pageIndex: 0, selectedPipeline: data.id })
                    getPiplines(1000, 0)
                        .then((res) => {
                            dispatch(setSelectedPipelineId(res[0].id))
                            dispatch(setSelectedPipelineName(res[0].name))
                            setPipelines(res)
                        })
                        .catch((e) => { })
                })

        }
        else {
            let label = focusedStage
            addPipeline(label)
                .then((data) => {
                    setShowPipelineModal(false)
                    toast.success("Pipeline has been updated successfully");
                    fetchData({ pageSize: 10, pageIndex: 0, selectedPipeline: data.id })
                    getPiplines(1000, 0)
                        .then((res) => {
                            setPipelines(res)
                            dispatch(setSelectedPipelineId(res[0].id))
                            dispatch(setSelectedPipelineName(res[0].name))
                        })
                        .catch((e) => { })
                })
        }
    }

    //This funtion is used to delete the stage
    const handleStageDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this attribute?')) {

            let body = {
                isDeleted: true,
            }
            editStageApi(selectedPipelineId, id, body)
                .then((data) => {
                    let d = [...dataApi];
                    d = d.filter(r => r.id != id)
                    setDataApi(d)
                    setShowStageModal(false)
                    toast.success("Stage has been deleted successfully");

                })
        }
    };

    //This funtion is used to Save the order of the stage
    const saveStageOrder = () => {
        let orderArr = [];
        dataApi.forEach((r, i) => {
            orderArr.push({ id: r.id, displayOrder: i });
        })
        saveOrderApi(selectedPipelineId, orderArr)
            .then((data) => {
                setshowSave(false)
                toast.success("Stage Order has been saved successfully");
                setOldOrder(null);
            })


    }
    const cancelStageOrder = () => {
        setDataApi(oldOrder)
        setOldOrder(null);
        setshowSave(false)
    }

    const handleStageModalClose = () => {
        setShowStageModal(false);
    }

    const handlePipelineModalClose = () => {
        setShowPipelineModal(false);
    }

    //This funtion is used to update the stage data when the pipeline is changed
    const handlePipelineChange = (e) => {
        // dispatch(setSelectedPipeline(e.target.value))
        dispatch(setSelectedPipelineId(e.target.value))
        dispatch(setSelectedPipelineName(e.target.options[e.target.selectedIndex].innerHTML))
        fetchData({
            pageSize: 10,
            pageIndex: 0,
            selectedPipeline: e.target.value
        });
    }
    return (
        <div className="settings">
            <div style={{ padding: '20px' }}>
                <p className="sm d-flex align-items-center">
                    You have a total of {pipelineCount} Pipeline(s) configured.
                </p>
            </div>
            <div className='head'>
                {pipelines &&
                    <select className="ml-4"
                        value={selectedPipelineId}
                        onChange={handlePipelineChange}
                    >
                        <option value="-1">Select Pipeline</option>
                        {
                            pipelines.map((r, i) => {
                                return <option key={i} value={r.id}>{r.name}</option>
                            })
                        }
                    </select>
                }
                <div>
                    <input
                        type="submit"
                        name="Save"
                        style={{ cursor: "pointer" }}
                        className="add__stage lg_btn primary"
                        value="Edit Pipeline"
                        onClick={() => {
                            setFocusedStage(selectedPipelineName)
                            setEditPipeline(selectedPipelineId)
                            setShowPipelineModal(true)
                        }}
                    />
                    <input
                        type="submit"
                        name="Save"
                        style={{ cursor: "pointer" }}
                        className="add__stage lg_btn primary"
                        value="Add Pipeline"
                        onClick={() => {
                            setFocusedStage(null);
                            setEditPipeline(null)
                            setShowPipelineModal(!showPipelineModal)
                        }}
                    />
                    <input
                        type="submit"
                        name="Save"
                        style={{ cursor: "pointer" }}
                        className="add__stage lg_btn primary"
                        value="Add Stage"
                        onClick={() => { setFocusedStage(null); setShowStageModal(!showStageModal) }}
                    />
                </div>

            </div>


            <ReactDragListView {...dragProps}>
                <Table
                    columns={columns}
                    data={data}
                    pageCount={pageCount}
                    fetchData={fetchData}
                    loading={companyUserLoading}
                ></Table>
            </ReactDragListView>

            <div className="tran-save w3-center w3-animate-top" style={showSave ? { display: 'flex' } : { display: 'none' }}>
                <input
                    type="submit"
                    name="Save"
                    style={{ margin_top: "2v", cursor: "pointer" }}
                    className="add lg_btn primary"
                    value="Save Order"
                    onClick={() => { saveStageOrder() }}
                />
                <div className="ml-3" ></div>
                <input
                    type="submit"
                    name="Cancel"
                    style={{ margin_top: "2v", cursor: "pointer", marginLeft: '22px' }}
                    className="ml-22 add lg_btn tertiary"
                    value="Cancel"
                    onClick={() => { cancelStageOrder() }}
                />
            </div>

            {showStageModal ?
                <CustomModal
                    title="Add Stage"
                    handleClose={handleStageModalClose}
                    show={showStageModal}
                    handleSave={handleStageUpdate}
                    body={<div style={{
                        padding: '20px 40px',
                        width: '100%'
                    }}>
                        <h6 style={{ fontSize: '17px', marginLeft: '10px', }}>Stage Name</h6>
                        <input
                            style={{
                                width: '80%',
                                padding: '7px',
                                margin: '10px',
                                outline: '2px'
                            }}
                            value={focusedStage}
                            onChange={(e) => setFocusedStage(e.target.value)}
                            placeholder='Type Name'
                        ></input> </div>
                    }
                />
                : null}
            {
                showPipelineModal ? <CustomModal
                    title="Add Pipeline"
                    handleClose={handlePipelineModalClose}
                    show={showPipelineModal}
                    handleSave={handlePipelineUpdate}
                    body={<div style={{
                        padding: '20px 40px',
                        width: '100%'
                    }}>
                        <h6 style={{ fontSize: '17px', marginLeft: '10px', }}>Pipeline Name</h6>
                        <input
                            style={{
                                width: '80%',
                                padding: '7px',
                                margin: '10px',
                                outline: '2px'
                            }}
                            value={focusedStage}
                            onChange={(e) => setFocusedStage(e.target.value)}
                            placeholder='Type Name'
                        ></input> </div>
                    }
                /> : null
            }

        </div>
    );
}
export default Stage;
